import { TranslateService } from '@ngx-translate/core';
import { computed, Inject, Injectable, Optional, PLATFORM_ID, Signal, signal } from '@angular/core';
import { REQUEST } from '@libs/configs/express.token';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { WINDOW } from '@libs/shared/injections/window';

export enum LanguagesEnum {
  ua = 'ua',
  ru = 'ru',
}

@Injectable({
  providedIn: 'root',
})
export class LangService {
  private lang = signal<LanguagesEnum>(LanguagesEnum.ua);
  public langPath: Signal<string> = computed(() => (this.lang() === LanguagesEnum.ru ? 'ru' : ''));

  constructor(
    @Inject(WINDOW) private readonly window: Window,
    @Inject(PLATFORM_ID) private platformId: any,
    @Optional() @Inject(REQUEST) private request: Request,
    private translate: TranslateService,
  ) {
    this.initializeLang();
  }

  public setLang(lang: LanguagesEnum): void {
    this.lang.set(lang);
    this.translate.use(lang);
  }

  public getLang(): LanguagesEnum {
    return this.lang();
  }

  private initializeLang(): void {
    let lang: LanguagesEnum = LanguagesEnum.ua;
    if (isPlatformServer(this.platformId) && this.request) {
      lang = (this.request['lang'] as LanguagesEnum) || LanguagesEnum.ua;
    } else if (isPlatformBrowser(this.platformId) && this.window) {
      lang = this.getLangFromUrl();
    }
    this.setLang(lang);
  }

  private getLangFromUrl(): LanguagesEnum {
    const pathname: string = this.window.location?.pathname || '';
    return pathname.startsWith('/ru') ? LanguagesEnum.ru : LanguagesEnum.ua;
  }
}
